<template>

  <Modal v-if="value" :value="value" :with-footer="false" width="xl" @input="close">
    <p slot="header">Entregas do webhook</p>

    <div class="row mb-2">
      <div class="col-md-8">
        <small :title="webhook.url" class="truncate-1">{{ webhook.url }}</small>
      </div>

      <div class="col-md-4 text-right">
        <button class="btn btn-outline btn-sm" @click="togglePayload">
          {{ withPayload ? 'Ocultar corpo enviado' : 'Ver corpo enviado' }}
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="wrap-table">
          <table class="table table-borderless table-border table-align table-h51">
            <thead>
              <tr>
                <th>Evento</th>
                <th>Situação</th>
                <th>Resposta</th>
                <th>Tentativas</th>
                <th>Próxima</th>
                <th>Criada em</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="delivery in deliveries">
                <tr :key="delivery.id">
                  <td class="nowrap">{{ delivery.eventType }}</td>
                  <td class="nowrap">{{ delivery.status | status }}</td>
                  <td :title="delivery.responseBody" class="truncate-1">
                    {{ delivery.responseCode }} {{ delivery.responseBody }}
                  </td>
                  <td>{{ delivery.attempts }}</td>
                  <td class="nowrap">{{ delivery.nextRetryAt | datetime }}</td>
                  <td class="nowrap">{{ delivery.createdAt | datetime }}</td>
                  <td class="text-right">
                    <button class="btn btn-sm btn-outline" title="Reenviar" @click="resend(delivery)">
                      <refresh-cw-icon size="1.3x"/>
                    </button>
                  </td>
                </tr>
                <tr v-if="withPayload" :key="`payload-${delivery.id}`">
                  <td colspan="7">
                    <pre><code v-text="format(delivery.payload)"></code></pre>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

  </Modal>

</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import Modal from '@/components/shares/specialTag/Modal'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import { RefreshCwIcon } from 'vue-feather-icons'

  const statuses = {
    pending: 'Aguardando reenvio',
    delivered: 'Entregue',
    failed: 'Não entregue'
  }

  export default {
    components: { Modal, Pagination, RefreshCwIcon },
    computed: {
      currentAxios() {
        return this.axios.v3
      },
      deliveries() {
        return this.getModels || []
      }
    },
    data() {
      return {
        nameModel: 'WebhookDelivery',
        withPayload: false
      }
    },
    filters: {
      status(value) {
        return statuses[value] || value
      }
    },
    methods: {
      buildPath() {
        return `webhooks/${this.webhook.id}/deliveries`
      },
      close() {
        this.$emit('input', false)
      },
      find() {
        this.methods = this.withPayload ? ['payload'] : []
        this.asyncTemplateSelect()
      },
      format(payload) {
        return payload ? JSON.stringify(payload, null, 2) : ''
      },
      resend(delivery) {
        this.openLoad()
        this.currentAxios.post(`webhooks/${this.webhook.id}/deliveries/${delivery.id}/resend`)
          .then(() => this.$notify.add('Reenvio enfileirado'))
          .then(() => this.find())
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
      togglePayload() {
        this.withPayload = !this.withPayload
        this.find()
      }
    },
    mixins: [ModelMapper],
    name: 'WebhookDeliveriesModal',
    props: {
      value: { default: false, type: Boolean },
      webhook: { default: () => ({}), type: Object }
    },
    watch: {
      value(opened) {
        if (opened) {
          this.withPayload = false
          this.find()
        }
      }
    }
  }
</script>

<style scoped>
</style>
